module.exports = __webpack_public_path__ + "static/media/faq.48f3d7d7.jpg";